<app-expandable-section-box
  [title]="title"
  [iconClass]="iconClass"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1" expandedContent>
    <mat-form-field appearance="outline">
      <mat-select [formControl]="sectionFormControl" place>
        <mat-option [value]="defaultOption">--Please select--</mat-option>
        <mat-option *ngFor="let option of options; index as i" [value]="option">
          {{ option[labelKey] }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    data-testid="preview"
    class="flex w-full p-4 m-0"
    *ngIf="
      sectionFormControl.value && sectionFormControl?.value !== defaultOption
    "
    notExpandedContent
  >
    <span class="text-xs text-project-2400" data-testid="preview-label">
      {{ sectionFormControl.value[labelKey] }}
    </span>
  </div>
</app-expandable-section-box>
